import React from "react";
import { uniqueId } from "lodash";
import { TouchableOpacity, View } from "react-native";
import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Ellipse,
} from "react-native-svg";

export default function LocationIcon(props) {
  const filterId = "paint0_linear_location" + uniqueId();
  const filterId2 = "paint1_linear_location" + uniqueId();
  const filterUrl = `url(#${filterId})`;
  const filterUrl2 = `url(#${filterId2})`;

  const w = props.width || 60;
  const h = props.height || 60;

  const TAG = props.onPress ? TouchableOpacity : View;

  return (
    <TAG style={props.style} {...props}>
      <Svg
        width={w}
        height={h}
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Ellipse
          opacity="0.5"
          cx="30"
          cy="51.75"
          rx="12"
          ry="3"
          fill={filterUrl}
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 20.75C10.75 10.3946 19.1447 2 29.5 2C39.8553 2 48.25 10.3946 48.25 20.75C48.25 31.9364 34.0523 46.3708 30.366 49.93C29.8803 50.399 29.1197 50.399 28.634 49.93C24.9477 46.3708 10.75 31.9364 10.75 20.75ZM35.75 20.75C35.75 24.2018 32.9518 27 29.5 27C26.0482 27 23.25 24.2018 23.25 20.75C23.25 17.2982 26.0482 14.5 29.5 14.5C32.9518 14.5 35.75 17.2982 35.75 20.75Z"
          fill={filterUrl2}
        />
        <Defs>
          <LinearGradient
            id={filterId}
            x1="18"
            y1="50.0512"
            x2="18.8818"
            y2="57.2584"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
          <LinearGradient
            id={filterId2}
            x1="10.75"
            y1="12.4707"
            x2="37.2997"
            y2="54.6057"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TAG>
  );
}
